// extracted by mini-css-extract-plugin
export var productImage = "_po-1";
export var viewLink = "_po-2";
export var wishlistItem = "_po-0";